'use strict';

define('Layout',[
        'LayoutDir',
        'SwitchLayoutForDir',
        'LayoutFac',
        'GTMMod'
    ],
    function (LayoutDir,
              SwitchLayoutForDir,
              LayoutFac) {

        angular.module('TVG.Layout', [
            'TVG.Common.GTM'
        ])

            .factory('LayoutFac', LayoutFac)

            .directive('layout', LayoutDir)
            .directive('switchLayoutFor', SwitchLayoutForDir);
    }
);

